export class S3SampleObject {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lastModified",
            "baseName": "lastModified",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageClass",
            "baseName": "storageClass",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3SampleObject.attributeTypeMap;
    }
    constructor() {
    }
}
